import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Progress, Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import StorageForm from './StorageForm';
import Card from './CardStyled';
import PopoverWrapper from './PopoverWrapper';

function StorageCard({ name, box, deleteData, data, edit }) {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  return (
    <PopoverWrapper>
      <Popover
        placement="bottomLeft"
        content={
          <StorageForm
            data={data}
            deleteData={deleteData}
            setVisible={setVisible}
            open={visible}
            edit={edit}
          />
        }
        className="rounded-lg"
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        trigger="click"
        visible={visible}
        onVisibleChange={() => {
          setVisible(!visible);
        }}
      >
        <Card className="rounded-lg shadow-card duration-300 hover:rounded-md">
          <Row align="middle">
            <Col span={6}>
              {console.log(`${(box.total - box.available)*100} / ${box.total}`)}
              <Progress
                strokeWidth={3}
                strokeColor={
                  box.total === 0
                    ? '#F4F8FB'
                    : {
                        '10%': '#FF3D3D',
                        '25%': '#F6B128',
                        '90%': '#4CD964',
                      }
                }
                type="circle"
                width={57}
                percent={`${(box.total - box.available)*100 / box.total}`}
                format={(percent) => {
                  if (box.total === 0) {
                    return 0;
                  } else {
                    return `${(box.total - box.available)}/${box.total}`;
                  }
                }}
              />
            </Col>
            <Col span={18}>
              <Link to={`storages/${data.id}`}>
                <div className="font-semibold text-16 text-black">{name}</div>
              </Link>

              <Button
                onClick={() => {
                  setVisible(!visible);
                }}
                type="primary"
                className="p-0"
                type="link"
              >
                <span style={{ borderBottom: '1px dotted #4b97e9' }}>
                  {visible ? t('hide') : t('more')}
                </span>
              </Button>
            </Col>
          </Row>
        </Card>
      </Popover>
    </PopoverWrapper>
  );
}

StorageCard.propTypes = {};

export default StorageCard;
